import React from 'react';
import Reorderable from '@dashboard/components/Reorderable';
import { useTicketGroupEdit } from '../TicketGroupEditContext';
import TicketTypeItem from './TicketTypeItem';

export default function TicketTypesList({ ticketTypes, ticketGroupId }) {
  const { onReorderTicketTypes } = useTicketGroupEdit();

  return (
    <Reorderable.Wrapper>
      <Reorderable
        id="ticketTypes"
        className="flex flex-col gap-y-2"
        items={ticketTypes}
        onReorder={ticketTypes => onReorderTicketTypes(ticketGroupId, ticketTypes)}
        renderItem={({ item: ticketType, dragHandleProps, isDragging }) => (
          <Reorderable.Item isDragging={isDragging} border={false}>
            <TicketTypeItem
              ticketType={ticketType}
              ticketGroupId={ticketGroupId}
              dragHandleProps={dragHandleProps}
            />
          </Reorderable.Item>
        )}
      />
    </Reorderable.Wrapper>
  );
}
